import { useLookbookProductsContext } from '@app/components/lookbook/context/LookbookProductsContext';
import { SkeletonLayout } from '@app/components/various/SkeletonLayout';
import { getLookbookProductsGridSize } from '@app/ducks';
import { cn } from '@app/utils/cn';
import { useSelector } from 'react-redux';

import { ProductCardSkeleton } from '../ProductCard/ProductCardSkeleton';

import { LookbookLoadMoreProducts } from './LookbookLoadMoreProducts';
import { LookbookProductCard } from './LookbookProductCard';

export const LookbookProductsList = () => {
  const gridSize = useSelector(getLookbookProductsGridSize);
  const { totalItems, pageCount, fetchNextPage, isLoadingNextPage, isLoading, sortedProducts } = useLookbookProductsContext();

  return (
    <div
      className={cn('mx-4 mr-0 grid pb-16 pr-4 pt-3 lg:pr-8 lg:pt-1', {
        'gap-x-5 gap-y-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-[repeat(auto-fill,minmax(21.5rem,1fr))]': gridSize === 'large',
        'grid-cols-[repeat(auto-fill,minmax(10.75rem,1fr))] gap-x-1 gap-y-1': gridSize === 'small',
        'grid-cols-[repeat(auto-fill,minmax(8.5rem,1fr))] gap-x-3 gap-y-3 md:!grid-cols-[repeat(auto-fill,minmax(13.5rem,1fr))] xs:grid-cols-[repeat(auto-fill,minmax(10rem,1fr))]':
          gridSize === 'medium',
      })}
    >
      <SkeletonLayout skeleton={<ProductCardSkeleton />} repeatLayout={12} isLoading={isLoading}>
        {sortedProducts.map(product => (
          <LookbookProductCard key={product.product} gridSize={gridSize} productInfo={product} />
        ))}
      </SkeletonLayout>
      <LookbookLoadMoreProducts
        isLoadingProducts={isLoading}
        isLoadingMoreProducts={isLoadingNextPage}
        onLoadMore={fetchNextPage}
        totalItems={totalItems}
        pageCount={pageCount}
        loadedCount={sortedProducts.length}
      />
    </div>
  );
};
